// extracted by mini-css-extract-plugin
export default {"container":"_GOIL829ev_product-carousel"};